<template>
    <ResponsiveDialog :value="value" @input="$emit('input', $event)" :max-width="420" :full-height="false" :header-title="$t('journey.mewtwoChallenge.title')" header-class="skin-window-header--mewtwo" card-class="skin-card">
        <div class="mewtwo-dialog-bg skin-window--mewtwo">
            <div class="mewtwo-dialog-banner">
                <v-img
                    :src="require('@/assets/pic/web/mewtwo_chalenge.png')"
                    class="mewtwo-dialog-banner-fg"
                    contain
                />
            </div>
            <div class="mewtwo-dialog-content">
                <div class="mewtwo-dialog-message">
                    {{ $t('journey.mewtwoChallenge.message') }}
                </div>
                <div
                    class="mewtwo-dialog-action-pill"
                    :class="{'mewtwo-dialog-action-pill--disabled': !canGo || isLoading}"
                    @click="canGo && !isLoading && accept()"
                >
                    <!-- bez explicitního color propu - ikona zdědí currentColor od pilulky, hitech skin je theme-adaptivní -->
                    <template v-if="!canGo">
                        {{ $t('journey.mewtwoChallenge.notEnoughSteps') }} <span class="ml-1">- {{ stepCost }}</span> <v-icon size="24" class="ml-1">mdi-shoe-print</v-icon>
                    </template>
                    <template v-else>
                        {{ $t('journey.mewtwoChallenge.accept') }}
                        <span class="ml-1">- {{ stepCost }}</span> <v-icon size="24" class="ml-1">mdi-shoe-print</v-icon>
                    </template>
                </div>
            </div>
        </div>
    </ResponsiveDialog>
</template>

<script>
    // Popup před Mewtwo challenge dlaždicí v CityNext.vue - stejná kostra
    // jako WildBackToCityDialog.vue/OfficerJennyDialog.vue.
    //
    // Backend `PositionService::stepMoveDecrementer()` bez client-side gatu
    // vyhodí nezachycenou 500 chybu, viz i B4 v roadmap.md.
    import ResponsiveDialog from '@/components/utils/ResponsiveDialog';

    // jediný zdroj pravdy pro FE gate - stejná hodnota jako backend `MeetMewtwoAction.php` odečte celkem
    const MEWTWO_STEP_COST = 6;

    export default {
        name: 'MewtwoChallengeDialog',
        components: {ResponsiveDialog},
        props: {
            value: {type: Boolean, default: false},
            availableSteps: {type: Number, default: 0},
            isLoading: {type: Boolean, default: false},
        },
        computed: {
            stepCost() {
                return MEWTWO_STEP_COST;
            },
            canGo() {
                return this.availableSteps >= MEWTWO_STEP_COST;
            },
        },
        methods: {
            accept() {
                this.$emit('input', false);
                this.$emit('accept');
            },
        },
    }
</script>

<style scoped>
.mewtwo-dialog-bg {
    flex: 1 1 auto;
    min-height: 0;
    /* pozadi ridi skin (public/skins/normal.css, .skin-window--mewtwo) */
    display: flex;
    flex-direction: column;
}
/* obrázek souboje (arena) za Mewtwo+Giovanni artworkem, škáluje se společně s bannerem, ne s celým popupem */
.mewtwo-dialog-banner {
    position: relative;
    flex: none;
    height: min(25vh, 200px);
    width: 80%;
    margin: 16px auto 0;
    border-radius: 16px;
    overflow: hidden;
    background-image: url('@/assets/pic/position/MEWTWO_FIGHT.png');
    /* nižší zoom ukáže větší část obrázku, rámeček (výška/šířka banneru) zůstává stejný */
    background-size: 180%;
    background-position: center;
    background-repeat: no-repeat;
    /* background-color/box-shadow ridi skin (public/skins/normal.css) */
}
/* 20% mezera shora i zdola - `contain` zmenší figurky do zbývajících 60% výšky rámečku */
.mewtwo-dialog-banner-fg {
    position: absolute;
    top: 20%;
    bottom: 20%;
    left: 0;
    right: 0;
    width: 100%;
}
.mewtwo-dialog-content {
    flex: 1 1 auto;
    min-height: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 20px;
    /* rezerva pro plovoucí zavírací křížek (ResponsiveDialog), stejná hodnota jako ostatní next/ popupy */
    padding: 24px 20px var(--responsive-dialog-close-clearance) 20px;
}
.mewtwo-dialog-message {
    text-align: center;
    font-size: 18px;
    font-weight: 700;
    /* color ridi skin (public/skins/normal.css) */
}
.mewtwo-dialog-action-pill {
    font-size: 18px;
    font-weight: 700;
    padding: 12px 24px;
    /* stejný mechanismus jako --skin-card-radius v ResponsiveDialog.vue, zděděno z .skin-card na předkovi */
    border-radius: var(--skin-pill-radius, 999px);
    text-align: center;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
    min-width: 65%;
    display: flex;
    align-items: center;
    justify-content: center;
    /* background/color/box-shadow řídí skin (public/skins/normal.css); :active box-shadow je tam taky - scoped pravidlo by prohrálo na specificitě proti pozdějšímu skin <link> */
}
/* barva/pozadí natvrdo tady, ne skin CSS - základní skin pravidlo musí tuhle třídu vyloučit přes :not(), jinak by vyhrálo ono */
.mewtwo-dialog-action-pill--disabled {
    pointer-events: none;
    color: #fff;
    background: #BDBDBD;
    box-shadow: 1px 1px 4px 3px rgba(0,0,0,0.25), -1px -2px 6px 3px rgba(0,0,0,0.35) inset;
}
</style>
